import { ThemingConfig } from '@chakra-ui/react';

import blockElementRecipe from './blockElement';
import dialogRecipe from './dialog';
import nativeSelectRecipe from './nativeSelect';
import tableRecipe from './table';

const slotRecipes: ThemingConfig['slotRecipes'] = {
  blockElement: blockElementRecipe,
  dialog: dialogRecipe,
  nativeSelect: nativeSelectRecipe,
  table: tableRecipe,
};

export default slotRecipes;
